import { http } from '../../config/axios'

 const findOpcaoConsultaLote = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/opcaoconsultalote/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findOpcaoConsultaLote', error)
      throw Error(error.response.data)
    })
}

export default findOpcaoConsultaLote;
